import axios from 'axios';
const ayzAjax = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // 使用环境变量
    responseType: "json",
    timeout: 5000 // 请求超时时间
});
export default ayzAjax;